module.exports = __webpack_public_path__ + "static/img/wlxx-null.d8669e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wlxx-null.png
// module id = HK11
// module chunks = 1